"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSTS004_Detail = void 0;
const throttle_1 = __importDefault(require("lodash/throttle"));
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Colors_1 = require("../../../Colors");
const common_1 = require("../../../common");
const option_1 = require("../../../common/option");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const server_1 = require("../../../server");
const account_1 = require("../../base/account");
const layout_1 = require("../../base/layout");
const action_1 = require("../../menu/action");
const constant_1 = require("./constant");
const detailStyled_1 = require("./detailStyled");
const DSTS004_Detailed_Child_1 = require("./DSTS004_Detailed_Child");
const QnAHistoryTable_1 = require("./DSTS004_Detailed_Child/QnAHistoryTable");
const DSTS004_Detail = ({ root_id, depths, isHidePaging = false, isContent = false, isSearchAnswer = false, isHistory = false, isPopup = false, }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const [testData, setTestData] = (0, react_1.useState)([]);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    const [number, setNumber] = (0, react_1.useState)(depths);
    const isTeacher = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsTeacher)(state));
    const { data, refetch } = (0, server_1.useQnaList)({
        root_id,
        limit: 2,
        offset: isContent && number !== 0 && number % 2 !== 0 ? number - 1 : number,
        orderby: ['creation_time'],
        with_content: true,
    });
    const refetchList = (0, throttle_1.default)(() => refetch(), 1000, { leading: true, trailing: false });
    (0, react_1.useEffect)(() => {
        setNumber(depths);
    }, [depths]);
    (0, react_1.useEffect)(() => {
        root_id && refetchList();
    }, [root_id, number]);
    // React 컴포넌트 방식
    const MobileMenuName = ({ title, depths }) => (react_1.default.createElement("div", { className: "flex mobile_menu", style: { gap: 8 } },
        depths >= 2 && react_1.default.createElement(common_1.Button, { className: "btn_tur", text: "supportRoom.req" }),
        react_1.default.createElement("span", { className: "overText" }, title)));
    (0, react_1.useEffect)(() => {
        if (isTeacher)
            return;
        if (testData && testData.length > 0)
            dispatch((0, action_1.changeMobileMenuName)(
            //@ts-ignore
            react_1.default.createElement(MobileMenuName, { title: testData[0]?.title || 'Default Title', depths: depths })));
        else
            dispatch((0, action_1.changeMobileMenuName)('Q&A'));
    }, [testData, depths]);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { total_count, items, found_count } = data;
            if (found_count > 0) {
                setTestData(items);
                setTotalCount(total_count);
                return;
            }
        }
        setTestData([]);
        setTotalCount(0);
    }, [data]);
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe('REFETCH_QNA_LIST', refetchList);
        return () => {
            APP.eventManager.unsubscribe('REFETCH_QNA_LIST', refetchList);
        };
    }, []);
    /**
     * (onClick) 이전 페이지로 이동
     */
    const previousPage = () => {
        APP.eventManager.publish('UPDATE_DETAIL_MENU', {
            menuDetail: 'list',
            id: undefined,
        });
    };
    /**
     * Q&A 답변 상단 타이틀
     */
    const renderInfoTitle = (0, react_1.useMemo)(() => (react_1.default.createElement(layout_1.DetailTitleInfo, { title: testData && testData.length > 0 ? (react_1.default.createElement("div", { className: "flex", style: { gap: 8 } },
            depths >= 2 && react_1.default.createElement(common_1.Button, { className: "btn_tur", text: 'supportRoom.req' }),
            react_1.default.createElement("span", null, testData[0].title))) : null, previousPage: previousPage })), [testData, depths]);
    if (testData && testData.length > 0) {
        return (react_1.default.createElement(detailStyled_1.DSTL004ViewStyled, { className: `dsts004-detail qna-detail-list ${isHistory ? 'history' : 'wrapper-padding'}`, "$isTablet": isTablet, "$isMobile": isMobile, "$isDesktop": isDesktop, "$isPopup": isPopup },
            !isHistory && isDesktop && renderInfoTitle,
            testData.map((item) => (react_1.default.createElement("div", { className: "qna-container", key: item.id },
                react_1.default.createElement(DSTS004_Detailed_Child_1.QnAContents, { key: item.id, number: number, totalCount: totalCount, data: item, questionData: {
                        id: testData[0].id,
                        status: testData[0].status,
                    }, depths: depths, isCloseAnswer: !isTeacher ? testData.length === 2 : false, isQuestion: item.type === constant_1.QNA_TYPE.QUESTION, isHistory: isHistory })))),
            !isHistory && totalCount > 2 && (react_1.default.createElement(QnAHistoryTable_1.QnAHistoryTable, { isTeacher: isTeacher, filterItems: testData.map(t => t.id), root_id: root_id })),
            isHistory && (react_1.default.createElement(react_1.default.Fragment, null, totalCount > 2 && !isHidePaging && (react_1.default.createElement("div", { className: "btn_groups" },
                number !== 0 && (react_1.default.createElement(common_1.Button, { className: "btn btn_default xmd", text: "supportRoom.previousQuestion", option: {
                        buttonBeforeIcon: {
                            show: true,
                            name: 'arrow',
                            size: 22,
                            color: Colors_1.Colors.w_grey,
                        },
                    }, onClick: () => setNumber(number - 2) })),
                totalCount > number * 2 && (react_1.default.createElement(common_1.Button, { className: "btn btn_default xmd", text: "supportRoom.nextQuestion", option: {
                        buttonAfterIcon: {
                            show: true,
                            className: 'arrow-right',
                            name: 'arrow',
                            size: 22,
                            color: Colors_1.Colors.w_grey,
                        },
                    }, onClick: () => setNumber(number + 2) }))))))));
    }
    return (react_1.default.createElement(detailStyled_1.DSTL004ViewStyled, { className: "dsts004-detail qna-detail-list no-data", "$isTablet": isTablet, "$isMobile": isMobile, "$isDesktop": isDesktop, "$isPopup": isPopup },
        react_1.default.createElement(option_1.EmptyTable, { title: "\uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.", iconProps: {
                icon: 'detail-delete',
                size: isMobile ? 28 : 32,
                color: Colors_1.Colors.w_grey,
            } })));
};
exports.DSTS004_Detail = DSTS004_Detail;
{
    /*

                {totalCount > 2 && !isHidePaging && (
                    <div className="btn_groups">
                        {number !== 0 && (
                            <Button
                                className="btn btn_default xmd"
                                text="supportRoom.previousQuestion"
                                option={{
                                    buttonBeforeIcon: {
                                        show: true,
                                        name: 'arrow',
                                        size: 22,
                                        color: Colors.w_grey,
                                    },
                                }}
                                onClick={() => setNumber(number - 2)}
                            />
                        )}

                        {totalCount > number * 2 && (
                            <Button
                                className="btn btn_default xmd"
                                text="supportRoom.nextQuestion"
                                option={{
                                    buttonAfterIcon: {
                                        show: true,
                                        className: 'arrow-right',
                                        name: 'arrow',
                                        size: 22,
                                        color: Colors.w_grey,
                                    },
                                }}
                                onClick={() => setNumber(number + 2)}
                            />
                        )}
                    </div>
                )} */
}
